/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsSettings/Settings/Content/SaveAction",
  disabled,
  onSubmit
  
}) {
let commsSettingsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'comms_settings',
})
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 alignSelf="flex-end"
 marginTop={dtSpaceL}
 disabled={disabled}
 data="comms_settings"
 onClick={commsSettingsSubmitData}
 text="Save"
/>
{children}
</React.Fragment>)
}